import { useMutation } from "@tanstack/react-query";

import { requests } from "api";

export const useRegisterMutation = () => {
  return useMutation({
    mutationFn: requests.legalCabinetGatewayRegister
  });
};
